<template>
  <div class="lottery-box">
    <!-- <div class="lottery-fun" v-if="userInfo.prize_list.length !== 0">
      <div class="lottery-win">{{ winMsg }}</div>
      <div class="lottery-slide swiper-no-swiping">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
        >
          <swiper-slide
            v-for="(item) in userInfo.prize_list"
            :key="item.id"
            :class="item.prize ? 'lottery-bg-win' : 'lottery-bg-no'"
          >
            <div class="lottery-win-msg" v-if="item.prize">
              <p class="lottery-msg-money">
                {{ item.minus }}
              </p>
              <h3 class="lottery-msg-detail">
                <p>优惠券</p>
                <span class="lottery-msg-full">{{ item.name | specificCoupon(item.name) }}</span>
              </h3>
            </div>
            <div class="lottery-no-msg" v-else>
              下次一定
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div :class="userInfo.status_lottery === 0 ? ['lottery-btn', 'no-lottery'] : 'lottery-btn'" @click="goLottery">
        立即抽奖
      </div>
    </div> -->
    <div class="lottery-list" v-if="userInfo.prize_list.length !== 0">
      <div
        v-for="(item) in userInfo.prize_list"
        :key="item.id"
        :class="'item ' + (itemId == item.id ? 'act' : '')"
        @click="selectTicket(item)"
      >
        <div class="lottery-win-msg" v-if="item.prize">
          <p class="lottery-msg-money">
            {{ item.minus }}
          </p>
          <h3 class="lottery-msg-detail">
            <p>优惠券</p>
            <span class="lottery-msg-full">{{ item.name | specificCoupon(item.name) }}</span>
          </h3>
        </div>
        <div class="lottery-no-msg" v-else>
          下次一定
        </div>
      </div>
    </div>

    <div :class="userInfo.status_lottery === 0 ? ['lottery-btn', 'no-lottery'] : 'lottery-btn'" @click="goLottery">
      立即领取
    </div>
    <div class="lottery-msg" style="margin-top: 20px">
      <p>活动规则：</p>
      <span>每日0点重置，每日可获取一次自选优惠券的机会！</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { startLottery } from '@/api/common'
// import 'swiper/dist/css/swiper.css'
export default {
  name: 'couponModule',
  data() {
    let that = this
    return {
      showActiveIndex: 0,
      swiperOption: {
        slidesPerView: 'auto',
        noSwiping: true,
        spaceBetween: 10,
        direction: 'vertical',
        autoplay: {
          disableOnInteraction: false,
          delay: 0
        },
        speed: 800,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: function() {
            that.showActiveIndex = this.realIndex
          }
        },
        loop: true,
        loopPreventsSlide: false
      },
      timer: null,
      nextSlide: false,
      winMsg: '',
      itemId: 0
    }
  },
  filters: {
    specificCoupon(str) {
      return str.substring(0, str.indexOf('减')) + '元可用'
    }
  },
  components: {
    // swiper,
    // swiperSlide
  },
  computed: {
    ...mapState(['userInfo']),
    lotterySwiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper
    },
  },
  mounted() {
  },
  methods: {
    selectTicket(item){
      this.itemId = item.id
    },
    goLottery() {
      if (this.userInfo.status_lottery !== 1) {
        this.$message({
          type: 'error',
          message: '今日已领取，请明日再来'
        })
        return false
      }
      startLottery({gift_id: this.itemId}).then((res) => {
        if (res && res.code === 0) {
          // this.lotterySwiper.autoplay.start()
          // this.lotterySwiper.params.speed = 50
          // this.timer = setTimeout(() => {
          //   let stopIndex = this.userInfo.prize_list.findIndex((item) => item.id === res.data.gift_id)
          //   if (this.showActiveIndex > stopIndex || this.showActiveIndex === stopIndex) {
          //     if (this.showActiveIndex === 6 && stopIndex === 6) {
          //       this.lotterySwiper.slideToLoop(this.userInfo.prize_list.length, 800, false)
          //       this.lotterySwiper.slideToLoop(this.userInfo.prize_list.length + stopIndex, 950, false)
          //       this.lotterySwiper.slideToLoop(6, 1000, false)
          //     } else {
          //       this.lotterySwiper.slideToLoop(this.userInfo.prize_list.length, 800, false)
          //       this.lotterySwiper.slideToLoop(this.userInfo.prize_list.length + stopIndex, 950, false)
          //     }
          //   } else {
          //     this.lotterySwiper.slideToLoop(this.userInfo.prize_list.length, 800, false)
          //     this.lotterySwiper.slideToLoop(stopIndex, 950, false)
          //   }
          //   this.lotterySwiper.autoplay.stop()
          //   clearTimeout(this.timer)
          //   setTimeout(() => {
          //     this.$store.dispatch('getUserInfo')
          //     this.isLock = false
          //     if (stopIndex === 0) {
          //       this.winMsg = '很遗憾'
          //     } else {
          //       this.winMsg = '恭喜获得优惠券'
          //     }
          //   }, 1000)
          // }, 3000)
          this.itemId = 0
          this.userInfo.status_lottery = 0
          this.$message({
            type: 'success',
            message: '优惠券已领取快去使用吧！'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.msg
        })
      })
    },
  },
};
</script>
<style lang="less" scoped>
.lottery-list{
  padding-top: 10px;
  width: 712px;
  margin: 0 auto;
}
  .item {
    width: 326px;
    height: 82px !important;
    float: left;
    background: url("~@/assets/images/lottery-win-bg.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin: 15px;
    box-shadow: 0 0 3px #999;
    cursor: pointer;
    .lottery-bg-win {
      background: url("~@/assets/images/lottery-win-has.png");
      background-size: contain;
      background-repeat: no-repeat;
    }
    .lottery-bg-no {
      
    }
    .lottery-win-msg {
      width: 250px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 0 auto;
      margin-left: 0px;
      height: 100%;
      position: relative;
      z-index: 1;
      .lottery-msg-money {
        margin: 0;
        font-size: 56px;
        font-weight: 700;
        color: #f5892d;
        line-height: 1;
        // margin-right: 35px;
        text-align: right;
      }
      .lottery-msg-detail {
        width: 90px;
        // margin-right: 10px;
        margin-left: 50px;
        text-align: center;
        p {
          font-size: 29px;
          font-weight: 700;
          margin: 0;
          color: #ff833e;
        }
        .lottery-msg-full {
          font-weight: normal;
          font-size: 14px;
          color: #ff833e;
        }
      }
    }
    .lottery-no-msg {
      width: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 54px;
      font-weight: 700;
      color: #f5892d;
    }
  }
  .item.act{
    box-shadow: 0 0 15px #e62323;
  }
  .lottery-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow: hidden;
    .lottery-fun {
      width: 450px;
      height: 353px;
      background: url("@/assets/images/lottery-bg.png");
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 auto;
      margin-top: 65px;
      position: relative;
      .lottery-win {
        position: relative;
        margin: 0 auto;
        margin-left: 73px;
        width: 291px;
        line-height: 45px;
        height: 45px;
        font-size: 32px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin-top: 9px;
      }
      .lottery-slide {
        position: relative;
        margin: 0 auto;
        margin-left: 55px;
        margin-top: 27px;
        width: 326px;
        height: 134px;
        /deep/ .swiper-container {
          width: 100%;
          height: 100%;
          padding-top: 27px;
          background: transparent;
          box-shadow: inset 5px 5px 5px 5px rgba(169,66,21, 0.2);
          box-sizing: border-box;
        }
        /deep/ .swiper-wrapper {
          transition-timing-function: linear;
        }
        /deep/ .swiper-slide {
          width: 326px;
          height: 82px !important;
          box-sizing: border-box;
          // img {
          //   width: 330px;
          //   height: 82px;
          //   display: block;
          // }
        }
        .lottery-bg-win {
          background: url("~@/assets/images/lottery-win-has.png");
          background-size: contain;
          background-repeat: no-repeat;
        }
        .lottery-bg-no {
          background: url("~@/assets/images/lottery-win-bg.png");
          background-size: contain;
          background-repeat: no-repeat;
        }
        .lottery-win-msg {
          width: 250px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin: 0 auto;
          margin-left: 0px;
          height: 100%;
          position: relative;
          z-index: 1;
          .lottery-msg-money {
            margin: 0;
            font-size: 56px;
            font-weight: 700;
            color: #f5892d;
            line-height: 1;
            // margin-right: 35px;
            text-align: right;
          }
          .lottery-msg-detail {
            width: 90px;
            // margin-right: 10px;
            margin-left: 50px;
            text-align: center;
            p {
              font-size: 29px;
              font-weight: 700;
              margin: 0;
              color: #ff833e;
            }
            .lottery-msg-full {
              font-weight: normal;
              font-size: 14px;
              color: #ff833e;
            }
          }
        }
        .lottery-no-msg {
          width: 100%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 54px;
          font-weight: 700;
          color: #f5892d;
        }
      }
    }
    .lottery-btn {
      width: 245px;
      cursor: pointer;
      text-align: center;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      background: #fdda4c;
      margin: 0 auto;
      margin-top: 40px;
      color: #6c6b6a;
    }
    .no-lottery {
      background: #b3a589;
      cursor:no-drop
    }
    .lottery-msg {
      width: 400px;
      margin: 0 auto;
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      p {
        margin: 0;
        font-size: 16px;
        display: inline-block;
        font-weight: 700;
        color: #e62323;
      }
      span {
        font-size: 16px;
        color: #e62323;
      }
    }
  }
</style>